<template>
    <div class="dashboard_traffic card">
      <div class="filters">
        <div class="form_select">
          <div class="form-group--wrap">
            <tree-select
                v-model="filter.client_id"
                :options="client_list"
                :placeholder="translate('dashboard.traffic.client')"
                :clearable="true"
                :disabled="filter.custom_list != null"
                @input="change_input"
            />
          </div>
        </div>

        <div class="form_select">
          <tree-select
              :options="blocking_list"
              :multiple="false"
              v-model="filter.blocked"
              :placeholder="translate('dashboard.traffic.blocking')"
              :clearable="true"
              @input="change_input"
          />
        </div>

        <div class="form_select">
          <tree-select
              :options="location_list"
              :multiple="false"
              v-model="filter.location"
              :placeholder="translate('dashboard.traffic.location')"
              :clearable="true"
              @input="change_input"
          />
        </div>

        <div class="form_select">
          <div class="filter checkbox" v-if="$store.getters.getPermissions.permissionGod === true">
            <div class="info">
              {{ translate('dashboard.traffic.non_traffic') }}
            </div>
            <label class="switch" @click.prevent="filter.non_traffic = !filter.non_traffic">
              <input type="checkbox" v-model="filter.non_traffic">
              <span class="slider round"></span>
            </label>
          </div>
        </div>
        <div class="form_select"></div>
      </div>

      <div class="response_table">

        <div class="summary card" v-if="Object.keys(summary).length > 0">
          <p v-for="(sum, key) in summary" :key="key">
            <span>{{ translate("dashboard.traffic.summary." + sum.name) }}:</span>
            <span v-html="sum.value" />
          </p>
        </div>

        <table>
          <thead style="height: 50px; flex:0; display: inline-block">
            <tr>
              <th
                  class="pointer w60"
                  @click="change_filter('status')"
                  :class="{ selected: filter_type === 'status' }"
                  scope="col"
              >
                {{ translate('dashboard.traffic.status') }}
                <i
                    class="mdi mdi-arrow-down"
                    :class="{ reverse: filter_asc === 'desc' }"
                />
              </th>
              <th
                  class="pointer w100"
                  @click="change_filter('blocked')"
                  :class="{ selected: filter_type === 'blocked' }"
                  scope="col"
              >
                {{ translate('dashboard.traffic.blocked') }}
                <i
                    class="mdi mdi-arrow-down"
                    :class="{ reverse: filter_asc === 'desc' }"
                />
              </th>
              <th
                  class="pointer"
                  @click="change_filter('name')"
                  :class="{ selected: filter_type === 'name' }"
                  scope="col"
              >
                {{ translate('dashboard.traffic.dev_name') }}
                <i
                    class="mdi mdi-arrow-down"
                    :class="{ reverse: filter_asc === 'desc' }"
                />
              </th>
              <th
                  class="pointer"
                  @click="change_filter('hidden_name')"
                  :class="{ selected: filter_type === 'hidden_name' }"
                  scope="col"
              >
                {{ translate('dashboard.traffic.hidden_name') }}
                <i
                    class="mdi mdi-arrow-down"
                    :class="{ reverse: filter_asc === 'desc' }"
                />
              </th>
              <th
                  class="pointer"
                  @click="change_filter('location')"
                  :class="{ selected: filter_type === 'location' }"
                  scope="col"
              >
                {{ translate('dashboard.traffic.location') }}
                <i
                    class="mdi mdi-arrow-down"
                    :class="{ reverse: filter_asc === 'desc' }"
                />
              </th>
              <th scope="col">
                {{ translate('dashboard.traffic.tariff_name') }}
              </th>

              <th scope="col">
                {{ translate('dashboard.traffic.client') }}
              </th>
              <th
                  class="pointer"
                  @click="change_filter('spent')"
                  :class="{ selected: filter_type === 'spent' }"
                  scope="col"
              >
                {{ translate('dashboard.traffic.spent') }}
                <i
                    class="mdi mdi-arrow-down"
                    :class="{ reverse: filter_asc === 'desc' }"
                />
              </th>
              <th
                  class="pointer"
                  @click="change_filter('value')"
                  :class="{ selected: filter_type === 'value' }"
                  scope="col"
              >
                {{ translate('dashboard.traffic.value') }}
                <i
                    class="mdi mdi-arrow-down"
                    :class="{ reverse: filter_asc === 'desc' }"
                />
              </th>
              <th
                  class="pointer"
                  @click="change_filter('limit')"
                  :class="{ selected: filter_type === 'limit' }"
                  scope="col"
              >
                {{ translate('dashboard.traffic.limit') }}
                <i
                    class="mdi mdi-arrow-down"
                    :class="{ reverse: filter_asc === 'desc' }"
                />
              </th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="(element, key) in traffic_statistics" :key="key" class="tariff_item">
              <td :data-label="translate('dashboard.traffic.status')" class="w60">
                <span v-if="element.status" class="mdi mdi-access-point problem_device online" />
                <span v-else class="mdi mdi-access-point-off problem_device offline" />
              </td>
              <td :data-label="translate('dashboard.traffic.blocked')" class="w100">
                <span v-if="element.blocked " class="mdi mdi-lock-alert blocked" />
              </td>
              <td :data-label="translate('dashboard.traffic.dev_name')" >
                <router-link :to="{ path: '/device/' + element.fid} ">
                  {{ element.fid }}
                </router-link>
                <p>
                  {{ element.name }}
                </p>
              </td>
              <td :data-label="translate('dashboard.traffic.hidden_name')">
                {{ element.hidden_name }}
              </td>
              <td :data-label="translate('dashboard.traffic.location')">
                {{ element.location }}
              </td>
              <td :data-label="translate('dashboard.traffic.tariff_name')">
                {{ element.tariff_name }}
              </td>
              <td :data-label="translate('dashboard.traffic.client')">
                <router-link :to="'/client/' + element.client_id" class="link">
                  {{ element.client_name }}
                </router-link>
              </td>
              <td :data-label="translate('dashboard.traffic.spent')">
                {{ element.spent }}
              </td>
              <td :data-label="translate('dashboard.traffic.value')">
                {{ element.value }}
              </td>
              <td :data-label="translate('dashboard.traffic.limit')">
                {{ element.limit }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
</template>

<script>


export default {
  name: 'TariffTraffic',
  components: {
  },
  data () {
    return {
      traffic_stat: [],
      client_filter: [],
      summary: {},
      filter:{
        client_id: null,
        blocked: null,
        location: null,
        custom_list: null,
        non_traffic: false
      },
      filter_asc: "asc",
      filter_type: ""
    }
  },

  computed:{
    sended_filter(){
      let filter = []
      Object.keys(this.filter).forEach((item) => {
        if (this.filter[item] !== null && this.filter[item] !== undefined && this.filter[item] !== ""){
          filter[item] = this.filter[item]
        }
      })
      return filter
    },
    traffic_statistics() {
      let traffic_statistics = [...this.traffic_stat];
      if (this.filter.non_traffic){
        traffic_statistics = traffic_statistics.filter((stat) => {
          if (stat.value === 0){
            return stat
          }
        })
      }
      return traffic_statistics.sort(this.compareNumbers);
    },
    location_list(){
      return [
        {id: "Russia", label: "Russia" },
        {id: "Other", label: "Other"}
      ]
    },
    blocking_list(){
      return [
        {id: 1, label: this.translate("dashboard.traffic.blocked")},
        {id: 0, label: this.translate("dashboard.traffic.unblocked")}
      ]
    },
    client_list(){
      return this.$store.getters.getClientsList.map((client) => {
        if (this.client_filter.length > 0 && this.client_filter.indexOf(client.id) > -1){
          return {id: client.id, label: client.name }
        }
      }).filter((element) => { return element !== undefined })
    },
    opt_custom_list () {
      return this.$store.getters.getCustomListTree
    },
  },

  watch:{
    filter:{
      deep: true,
      handler() {
        if (this.$route.name === 'dashboard_section') {
          let string = '?'
          for (let key in this.filter) {
            switch (key) {
              case 'client_id':
              case 'blocked':
              case 'location':
                if (this.filter[key] !== null && this.filter[key] !== undefined && this.filter[key] !== "") {
                  string += '&' + key + '=' + this.filter[key]
                }
                break
              case 'non_traffic':
                string += '&' + key + '=' + Number(this.filter[key])
                break
            }
          }
          history.pushState(null, null, this.$route.path + string)
        }
      }
    },
  },

  created () {
    this.check_query()
  },

  methods: {
    get_client(client_id){
      const client = this.$store.getters.getClientById(client_id)
      return client ? client.name : ""
    },
    check_query(){
      if (Object.keys(this.$route.query).length > 0){
        for (let key in this.$route.query){
          switch (key) {
            case 'client_id':
            case 'blocked':
            case 'location':
              this.filter[key] = this.$route.query[key]
              break;
            case 'non_traffic':
              this.filter[key] = Number(this.$route.query[key]) === 1
              break;
          }
        }
      }
      this.change_input()
    },
    change_input () {
      if (this.timer !== null) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(this.dashboard_device_traffic, 200)
    },
    async dashboard_device_traffic(){
      await this.$http.v1.dashboardDeviceTraffic(this.sended_filter, (response) => {
        this.traffic_stat = response.data.data.map((item) => {
          return {
            ...item.traffic,
            ...item.device,
            spent: item.traffic.limit - item.traffic.value,
            client_id: item.client_id,
            client_name: this.get_client(item.client_id),
          }
        })

        this.client_filter = response.data.clients_filter
        this.summary = response.data.summary
      });
    },
  },
}

</script>

<style scoped lang="scss">
.dashboard_traffic{
  padding: 10px;
  margin-top: 10px;
  height: calc(100% - 10px);
  .header{
    padding: 0;
    .title{
      font-size: 20px;
      font-weight: 600;
      margin-bottom: 10px;
    }
  }

  .filters{
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 10px;
    .form_select{
      flex: 1;
      margin-right: 10px;
      &:last-child{
        margin-right: 0;
      }
    }
  }

  .response_table{
    padding: 0;
    height: calc(100% - 75px);
    tbody{
      &::-webkit-scrollbar {
        width: 10px;
      }
    }
    .summary{
      span{
        font-size: 12px;
      }
    }
    .tariff_item{
      font-size: 12px;
      p{
        margin-bottom: 0;
        font-size: 12px;
      }
      span{
        &.mdi{
          font-size: 18px;
        }
        &.online{
          color: #15ab00;
        }
        &.blocked{
          color: #ff4040;
        }
      }
    }
  }
}

</style>
